interface DragBlockParams {
  exceedsMaxHours: boolean;
  crossesMidnight: boolean;
  overlaps: boolean;
}

export function getDragBlockReason({
  exceedsMaxHours,
  crossesMidnight,
  overlaps
}: DragBlockParams): string | null {
  if (exceedsMaxHours) {
    return 'No se puede crear. El día ya alcanzó el máximo permitido';
  }
  if (crossesMidnight) {
    return 'No se puede asignar un rango único que atraviese las 00:00';
  }
  if (overlaps) {
    return 'Este rango se solapa con otro horario existente';
  }
  return null;
}